import React, { useEffect, useRef, useState } from "react";
import { fabric } from "fabric";
import $ from "jquery";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import IconCopy from "assets/icons/context-menu-icons/copy.svg";
import IconDelete from "assets/icons/context-menu-icons/delete.svg";
import IconClearAll from "assets/icons/context-menu-icons/clearall.svg";
import IconBringToFrontItems from "assets/icons/context-menu-icons/bringTofrontitems.svg";
import IconSendBackItems from "assets/icons/context-menu-icons/sendbackitems.svg";

import { ResizableBox } from 'react-resizable';

import {
  canvasInfoDataSelector
} from "selectors/canvasInfoSelector.js";
import { getCanvasInfo } from "actions/canvasInfoActions.js";
import "assets/stylesheets/App.css";

import {
  setCanvas,
  getCanvas,
  saveCanvasState,
  initCanvasEvents,
  addGroupedImage,
  resetState,
  updateSelectionCanvasItems,
  udpateGroupLabels,
  getIsExportPDF
} from "./Helpers";

let clipboard;

const FabricCanvas = ({ buyplanId }) => {
  const dispatch = useDispatch();
  const { month } = useParams();
  const canvasRef = useRef(null);
  let canvasData = useSelector(canvasInfoDataSelector);

  const [rezWidth, setRezwidth] = useState(0);
  const [rezHeight, setRezHeight] = useState(0);
  const [rezInitWidth, setRezInitWidth] = useState(0);
  const [rezInitHeight, setRezInitHeight] = useState(0);

  //get canvas data
  useEffect(() => {
  if (buyplanId && month) {

    dispatch(getCanvasInfo(buyplanId, month));
  }
  }, [dispatch, buyplanId, month]);

  //get canvas data
  useEffect(() => {

  const isExportPDF = getIsExportPDF();
  if (!isExportPDF && canvasData && canvasData !== "" && canvasData != true && $("#applyto_canvas").prop('checked')) {
    canvasData = canvasData.get("canvas_state") ? canvasData.get("canvas_state").get("canvas_state") : null;
    const canvas = getCanvas();
    if (canvasData && canvas) {
    canvas.loadFromJSON(JSON.stringify(canvasData), function () {
      canvas.renderAll.bind(canvas);
      canvas.requestRenderAll();
      updateSelectionCanvasItems();
      udpateGroupLabels();
      saveCanvasState();
    });
    }
  }
  }, [canvasData]);

  useEffect(() => {
  const canvas = new fabric.Canvas(canvasRef.current);
  canvas.preserveObjectStacking = true;

  setCanvas(canvas);

  resizeCanvas(canvas);

  resetState();

  initRightClick(canvas);
  initKeyboardEvents();
  initCanvasEvents();
  saveCanvasState();

  window.onresize = function () {
    resizeCanvas(canvas);
  };
  }, []);

  function resizeCanvas() {
  const canvas = getCanvas();
  if (canvas) {
    const w = $('.canvasArea').css('width').replace('px', '');
    const h = $('.canvasArea').css('height').replace('px', '');

    setRezwidth(parseInt(w));
    setRezHeight(parseInt(h));

    canvas.setDimensions({
    width: w,
    height: h
    });

    if (!rezInitWidth && !rezInitHeight) {//initial canvas w/h
    setRezInitWidth(w - 2);
    setRezInitHeight((h - 2) * 2);
    }

    canvas.calcOffset();
    canvas.renderAll();
  }
  }

  function onResize(e) {

  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  if (e.stopPropagation) {
    e.stopPropagation();
  }

  let w = e.clientX;
  let h = e.clientY;

  if (w < rezInitWidth)
    w = rezInitWidth
  if (h < 50)
    h = 50;
  if (w > rezInitWidth)
    w = rezInitWidth;
  if (h > rezInitHeight)
    h = rezInitHeight;

  $('.canvasArea').css('width', w + 'px');
  $('.canvasArea').css('height', h + 'px');

  resizeCanvas();
  }

  function initKeyboardEvents() {
  document.onkeyup = function (e) {
    e.preventDefault(); // Let's stop this event.
    e.stopPropagation(); // Really this time.
    if (e.which === 46) {
    deleteItems();
    }
    if (e.ctrlKey && e.which === 90) {
    //undo();
    }
    if (e.ctrlKey && e.which === 89) {
    //redo();
    }
    if (e.which === 71) {
    //group / ungroup items
    }
  };
  }

  function initRightClick() {
  $("canvas")
    .unbind("contextmenu")
    .on("contextmenu", function (e) {
    e.preventDefault();
    handleContextmenu(e);
    return false;
    });
  $(".canvas-area, .sidebar, .btn-toggle, .edit-box")
    .unbind("click")
    .on("click", function (e) {
    e.preventDefault();
    $(".custom-menu").hide(100);
    });
  $("canvas")
    .unbind("click")
    .on("click", function (e) {
    e.preventDefault();
    $(".custom-menu").hide(100);
    return false;
    });
  $(".custom-menu li")
    .unbind("click")
    .on("click", function () {
    switch ($(this).attr("data-action")) {
      case "selectall":
      selectallobjs();
      break;
      case "copy":
      copyobjs();
      break;
      case "cut":
      cutobjs();
      break;
      case "paste":
      pasteobjs(true);
      break;
      case "delete":
      deleteItems();
      break;
      case "clearall":
      clearallitems();
      break;
      case "bringTofrontitems":
      bringTofrontitems();
      break;
      case "sendTobackitems":
      sendTobackitems();
      break;
      case "objectflipvertical":
      objectflipvertical();
      break;
      case "duplicate":
      duplicateObject();
      break;
      case "objectfliphorizontal":
      objectfliphorizontal();
      break;
      case "groupItems":
      groupItems();
      break;
      case "unGroupItems":
      unGroupItems();
      break;
      default:
      break;
    }
    $(".custom-menu").hide(100);
    });
  }

  function handleContextmenu(e) {
  e.preventDefault();
  $(".custom-menu").hide(100);
  $("#context-menu")
    .show(100)
    .css({
    top: (e.pageY) + "px",
    left: e.pageX + "px",
    });
  }

  function selectallobjs() {
  const canvas = getCanvas();
  canvas.discardActiveObject();
  const sel = new fabric.ActiveSelection(canvas.getObjects(), {
    canvas: canvas,
  });
  canvas.setActiveObject(sel);
  canvas.requestRenderAll();
  }

  function copyobjs() {
  const canvas = getCanvas();
  const actObj = canvas.getActiveObject();
  if (actObj)
    actObj.clone(function (cloned) {
    clipboard = cloned;
    clipboard.set({
      pimage: actObj.pimage,
      pname: actObj.pname,
      skutxt: actObj.skutxt,
      productcolorcode: actObj.productcolorcode,
      productwprice: actObj.productwprice,
      productrprice: actObj.productrprice,
    });
    });
  canvas.requestRenderAll();
  }

  function cutobjs() {
  const canvas = getCanvas();
  const actObj = canvas.getActiveObject();
  if (actObj)
    actObj.clone(function (cloned) {
    clipboard = cloned;
    clipboard.set({
      pimage: actObj.pimage,
      pname: actObj.pname,
      skutxt: actObj.skutxt,
      productcolorcode: actObj.productcolorcode,
      productwprice: actObj.productwprice,
      productrprice: actObj.productrprice,
    });
    });
  canvas.remove(actObj);
  canvas.requestRenderAll();
  }

  function pasteobjs() {
  const canvas = getCanvas();
  clipboard.clone(function (clonedObj) {
    canvas.discardActiveObject();
    clonedObj.set({
    left: clonedObj.left + 10,
    top: clonedObj.top + 10,
    pimage: clipboard.pimage,
    pname: clipboard.pname,
    skutxt: clipboard.skutxt,
    productcolorcode: clipboard.productcolorcode,
    productwprice: clipboard.productwprice,
    productrprice: clipboard.productrprice,
    evented: true,
    });
    if (clonedObj.type === "activeSelection") {
    clonedObj.canvas = canvas;
    clonedObj.forEachObject(function (obj) {
      canvas.add(obj);
    });
    clonedObj.setCoords();
    } else {
    canvas.add(clonedObj);
    }
    clipboard.top += 10;
    clipboard.left += 10;
    canvas.setActiveObject(clonedObj);
    canvas.requestRenderAll();
  });
  saveCanvasState();
  }

  function clearallitems() {
  const canvas = getCanvas();
  canvas.clear();
  saveCanvasState();
  updateSelectionCanvasItems();
  }

  function bringTofrontitems() {
  const canvas = getCanvas();
  let activeObject = canvas.getActiveObject(),
    activeGroup = canvas.getActiveObjects();
  if (activeObject) {
    canvas.bringToFront(activeObject);
  } else if (activeGroup) {
    let objectsInGroup = activeGroup.getObjects();
    canvas.discardActiveGroup();
    objectsInGroup.forEach((object) => {
    canvas.bringToFront(object);
    });
  }
  canvas.requestRenderAll();
  saveCanvasState();
  }

  function sendTobackitems() {
  const canvas = getCanvas();
  let activeObject = canvas.getActiveObject(),
    activeGroup = canvas.getActiveObjects();
  if (activeObject) {
    canvas.sendToBack(activeObject);
  } else if (activeGroup) {
    let objectsInGroup = activeGroup.getObjects();
    canvas.discardActiveGroup();
    objectsInGroup.forEach((object) => {
    canvas.sendToBack(object);
    });
  }
  canvas.requestRenderAll();
  saveCanvasState();
  }

  function objectflipvertical() {
  const canvas = getCanvas();
  const activeObject = canvas.getActiveObject();
  const grpobjs = canvas.getActiveObjects();
  if (grpobjs) {
    grpobjs.forEach((object) => {
    if (object.flipY) object.flipY = false;
    else object.flipY = true;
    canvas.renderAll();
    });
  } else {
    if (activeObject.flipY) activeObject.flipY = false;
    else activeObject.flipY = true;
    canvas.renderAll();
  }
  saveCanvasState();
  }

  function duplicateObject() {
  const canvas = getCanvas();
  const activeObject = canvas.getActiveObject();
  activeObject.clone(function (cloned) {
    canvas.discardActiveObject();
    cloned.set({
    left: cloned.left + 20,
    top: cloned.top + 20,
    evented: true,
    layerType: activeObject.layerType,
    cusType: activeObject.cusType,
    pimage: activeObject.pimage,
    pname: activeObject.pname,
    skutxt: activeObject.skutxt,
    productcolorcode: activeObject.productcolorcode,
    productwprice: activeObject.productwprice,
    productrprice: activeObject.productrprice,
    });
    if (cloned.type === 'activeSelection') {
    cloned.canvas = canvas;
    cloned.forEachObject(function (obj) {
      canvas.add(obj);
    });
    cloned.setCoords();
    } else {
    canvas.add(cloned);
    }
    canvas.setActiveObject(cloned);
    canvas.requestRenderAll();
    saveCanvasState();
  });
  }

  function objectfliphorizontal() {
  const canvas = getCanvas();
  const activeObject = canvas.getActiveObject();
  const grpobjs = canvas.getActiveObjects();
  if (grpobjs) {
    grpobjs.forEach((object) => {
    if (object.flipX) object.flipX = false;
    else object.flipX = true;
    canvas.renderAll();
    });
  } else {
    if (activeObject.flipX) activeObject.flipX = false;
    else activeObject.flipX = true;
    canvas.renderAll();
  }
  saveCanvasState();
  }

  function groupItems() {
  const canvas = getCanvas();

  if (!canvas.getActiveObject()) {
    return;
  }
  if (canvas.getActiveObject().type !== "activeSelection") {
    return;
  }
  canvas.getActiveObject().toGroup();
  canvas.renderAll();
  saveCanvasState();
  }

  function unGroupItems() {
  const canvas = getCanvas();
  if (!canvas.getActiveObject()) {
    return;
  }
  if (canvas.getActiveObject().type !== "group") {
    return;
  }
  canvas.getActiveObject().toActiveSelection();
  canvas.renderAll();
  saveCanvasState();
  }

  function deleteItems() {
  const canvas = getCanvas();
  let activeObject = canvas.getActiveObject(),
    activeGroup = canvas.getActiveObjects();
  if (!activeObject && !activeGroup) return;
  if (activeGroup) {
    canvas.discardActiveObject().renderAll();
    activeGroup.forEach(function (object) {
    const objects = canvas.getObjects().filter(function (o) {
      return o.skutxt === object.skutxt;
    });
    if (objects.length === 1 && object.skutxt)
      $("#" + object.skutxt).show();
    canvas.remove(object);
    });
  }
  if (activeObject) {
    canvas.remove(activeObject);
  }
  saveCanvasState();
  canvas.renderAll();
  }

  function handleDragOver(e) {
  e.stopPropagation();
  e.preventDefault();
  }

  function handleDrop(e) {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  if (e.stopPropagation) {
    e.stopPropagation();
  }
  const dropPositionX = e.pageX - $(".canvas-area").offset().left;
  const dropPositionY = e.pageY - $(".canvas-area").offset().top;
  const canvas = getCanvas();
  const options = {
    left: dropPositionX / canvas.getZoom(),
    top: dropPositionY / canvas.getZoom(),
  };
  if (e.dataTransfer.getData("name") === "image") {
    const pimage = e.dataTransfer.getData("imageUrl");
    const pname = e.dataTransfer.getData("productname");
    const skutxt = e.dataTransfer.getData("productsku");
    const productcolorcode = e.dataTransfer.getData("productcolorcode");
    const productwprice = e.dataTransfer.getData("productwprice");
    const productrprice = e.dataTransfer.getData("productrprice");
    addGroupedImage(pimage, options, pname, skutxt, productcolorcode, productwprice, productrprice);
    saveCanvasState();
    $("#" + skutxt).hide();
  }
  }

  return (
  <div>
    <ul className="custom-menu" id="context-menu">
    <li data-action="duplicate">
      <img src={IconCopy} alt="" />{" "}
      Duplicate
    </li>
    <li data-action="delete">
      <img src={IconDelete} alt="" />{" "}
      Delete
    </li>
    <li data-action="clearall">
      <img src={IconClearAll} alt="" />{" "}
      Clear All
    </li>
    <li data-action="bringTofrontitems">
      <img src={IconBringToFrontItems} alt="" />{" "}
      Bring to Front
    </li>
    <li data-action="sendTobackitems">
      <img src={IconSendBackItems} alt="" />{" "}
      Send to Back
    </li>
    </ul>
    <ResizableBox width={rezWidth} className="resize-canvasarea" height={rezHeight} onResize={onResize} handleSize={[20, 20]} draggableOpts={{ grid: [25, 25] }}
    minConstraints={[rezInitWidth, 100]} maxConstraints={[rezInitWidth, rezInitHeight]}>
    <div
      className="canvas-area"
      onDragOver={(event) => handleDragOver(event)}
      onDrop={(event) => handleDrop(event)}
    >
      <canvas ref={canvasRef} width="1550" height="800" />
    </div>
    </ResizableBox>
  </div>
  );
};

export default FabricCanvas;
